module.exports = { apiServer: 'https://api.i-natural.com.hk', AdminServer: 'https://nadmin.i-natural.com.hk' };
